<section class="container-fluid px-4 custom-height">
    <div class="row mt-4">
        <div class="col-12">
            <section class="addNavbar mb-3">

                 <div>
                    <button
                        mat-button
                        class="m-1 secondary-gray-button-2"
                        [disabled]="!hasActiveFilters && !hasStoredPreferences"
                        [matMenuTriggerFor]="resetMenu">
                        <mat-icon>filter_alt_off</mat-icon>
                        {{ 'reset' | translate }}
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>

                    <mat-menu #resetMenu="matMenu">
                        <button mat-menu-item [disabled]="!hasActiveFilters" (click)="resetAllFilters()">
                            <mat-icon>filter_alt_off</mat-icon>
                            {{ 'filters.reset_results' | translate }}
                        </button>
                        <button mat-menu-item [disabled]="!hasStoredPreferences" (click)="resetGridPreferences()">
                            <mat-icon>tune</mat-icon>
                            {{ 'reports.reset_preferences' | translate }}
                        </button>
                    </mat-menu>

                    <button mat-button class="m-1 secondary-gray-button-2"  [matMenuTriggerFor]="exportReport">
                        <mat-icon>download</mat-icon> {{'reports.export_report' | translate}}
                    </button>

                    <mat-menu  #exportReport="matMenu">
                        <button mat-menu-item (click)="exportExcel();">{{'reports.excel' | translate}}</button>
                        <button mat-menu-item (click)="exportCsv();">{{'reports.csv' | translate}}</button>
                    </mat-menu>
                </div>

                <div class="fs-5">{{displayName}}</div>
               
                <mat-form-field class="pt-3 my-0 search" subscriptSizing="dynamic">
                    <mat-label>{{'search_title' | translate}}</mat-label>
                    <input matInput (input)="onQuickFilterChanged($event.target['value'])" placeholder="{{'search' | translate}}" #input>
                    <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>

                </section>
        </div>
    </div>

    <mat-progress-bar mode="indeterminate" [style.visibility]="reportLoadFromNextId ? 'visible' : 'hidden' "></mat-progress-bar>

    @if (selectedTridys.length) {
        <div class="selection-toolbar">
            <span>{{selectedTridys.length}} {{'selected' | translate}}</span>
            <button mat-button class="orange-button" (click)="openQrExportDialog()">
                <mat-icon>download</mat-icon> {{'tridys.qrExport.downloadZip' | translate}}
            </button>
        </div>
    }

    <div class="content" style="width: 100%; height: 100%">
        <ag-grid-angular style="width: 100%; height: 100%;" #agGridReports
            [rowData]="reportsList"
            [rowSelection]="rowSelection"
            [selectionColumnDef]="selectionColumnDef"
            (selectionChanged)="onSelectionChanged($event)"
            [rowHeight]="50"
            [excelStyles]="excelStyles"
            [localeText]="localeText"
            enableCellTextSelection="true"
            [columnDefs]="displayedColumnsAG"
            [defaultColDef]="{ resizable: true }"
            [theme]="theme"
            (gridReady)="onGridReady($event)"
            [autoSizeStrategy]="autoSizeStrategy"
            (filterChanged)="onFilterChanged()"
            (sortChanged)="onSortChanged()"
            (columnResized)="onColumnChanged()"
            (columnMoved)="onColumnChanged()"
            (columnVisible)="onColumnChanged()"
            (columnPinned)="onColumnChanged()"
            (paginationChanged)="onPaginationChanged()"
            [pagination]="paginationAndFiltering"
            [paginationPageSizeSelector]="paginationPageSizeSelector"
            [dataTypeDefinitions]="dataTypeDefinitions"
            [gridOptions]="gridOptions"
            [cellSelection]="true"
            (cellClicked)="onCellClicked($event)"
            [masterDetail]="masterDetail"
            [isRowMaster]="isRowMaster"
            [detailCellRendererParams]="detailCellRendererParams"
            [detailRowAutoHeight]="detailRowAutoHeight"
        />
    </div>
</section>
